export default "__VITE_ASSET__DvEonS1h__"